<mc-full-navbar></mc-full-navbar>

<main class="page page-full page-centered mc-brand-gradient">
  <router-outlet></router-outlet>
</main>
